<template>
    <Dashboard
        :title="__('Images', null, $page.props.profile_locale)"
    >
        <Heading
            :label="__('Images', null, $page.props.profile_locale)"
        />

        <Tabs
            :link="true"
            :tabs="[
                { slug: 'list', title: __('Engraving variants', null, $page.props.profile_locale), route: 'dashboard.engrave.index' },
                { slug: 'piktogram', title:__('Images', null, $page.props.profile_locale), route: route().current() },
            ]"
        >

            <ItemTab key="piktogram" class="mt-4">
                <div class="overflow-auto w-full shadow-md rounded-md">
                    <table class="w-full whitespace-nowrap">
                        <thead class="relative">
                            <tr
                                class="text-xs font-semibold tracking-wide text-left text-gray-200 uppercase border-b bg-gray-900 border-red-700">
                                <th class="px-4 py-3">{{__('Title', null, $page.props.profile_locale)}}</th>
                                <th class="px-4 py-3">{{__('Image', null, $page.props.profile_locale)}}</th>
                                <th class="px-4 py-3">{{__('Actions', null, $page.props.profile_locale)}}</th>
                            </tr>
                            <InertiaLink
                                :href="route('dashboard.engrave.pictogram.create')"
                                class="absolute top-1/2 right-2 transform -translate-y-1/2 rounded-full overflow-hidden hover:text-white text-gray-200"
                            >
                                <SvgIcon
                                    name="plus-circle"
                                    class="mx-auto "
                                />

                            </InertiaLink>
                        </thead>
                        <tbody class="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
                            <tr v-for="item in pictogram.data" :key="item.id"
                                class="bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-900 text-gray-700 dark:text-gray-400">
                                <td class="p-3 font-bold">
                                    {{ item.name }}
                                </td>
                                <td>
                                    <img
                                        :src="item.url"
                                        class="max-w-full max-h-full object-contain object-center group-hover:opacity-50 transition duration-300"
                                    />
                                </td>
                                <td class="px-4 py-3 flex">
                                    <IconLink
                                        class="mx-1 p-1"
                                        icon="pencil"
                                        :size="30"
                                        :href="route('dashboard.engrave.pictogram.edit', item.id)"
                                    />
                                    <IconLink
                                        class="mx-1 p-1"
                                        icon="trash"
                                        color="red"
                                        :size="30"
                                        href="#"
                                        @click.prevent="remove(item)"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <PaginateLink
                    class="mt-5"
                    :links="pictogram.links"
                />
            </ItemTab>
        </Tabs>
    </Dashboard>
</template>

<script>
import Dashboard from '@/Layouts/Dashboard';
import SvgIcon from 'UI/SvgIcon';
import IconLink from 'UI/IconLink';
import { Inertia } from '@inertiajs/inertia';
import Button from 'UI/Button';
import Tabs from 'COMP/Tabs/Container';
import ItemTab from 'COMP/Tabs/Tab';
import { ref } from '@vue/reactivity';
import Heading from 'COMP/Heading';
import { provide } from '@vue/runtime-core';
import PaginateLink from 'UI/PaginateLink';

export default {
    components: { Dashboard, SvgIcon, IconLink, Button, Tabs, ItemTab, Heading, PaginateLink},

    props: {
        pictogram: [Array, Object],
    },

    setup(props) {

        const activeTab = ref(0);

        const loading = ref(true);
        provide('loading', loading);

        function remove(ev){
            if(confirm("Czy napewno chcesz usunąć grawer ?")){
                Inertia.visit(route('dashboard.engrave.pictogram.remove', ev.id), { method: 'post' });
            }
        }

        return {
            activeTab,
            remove,
        }
    }
}
</script>

<style>

</style>
